<template>
  <router-view v-slot="{ Component, route }">
      <component :is="Component" :key="route.fullPath" />
  </router-view>
</template>

<script setup lang="ts">
// Root app shell. Layouts are picked per-route via meta.layout / nested components.
</script>
